import React from 'react';
import { areEqual } from 'react-window';
import { ImageType, type LibItemSysImage } from '@types';
import type { ItemListRowProps } from '@components/ItemList';
import Image from '@components/Image';
import onItemClick from '../actions/onItemClick';
import LibItemContainer from '../layouts/LibItemContainer';
import ItemCheckBox from '../components/ItemCheckBox';
import LibItemName from '../layouts/LibItemName';

interface Props extends ItemListRowProps {
  data: {
    items: LibItemSysImage[];
  };
}

function RowImage({ index, data, style }: Props) {
  const { items } = data;

  const item = items[index];

  return (
    <LibItemContainer style={style} onClick={() => onItemClick(item.id)}>
      <ItemCheckBox id={item.id} />
      <Image
        src={item.url}
        size={32}
        type={ImageType.sysMedia}
        className="ml-20 h-32 w-32 cursor-pointer bg-white-border"
      />
      <LibItemName>{item.name}</LibItemName>
    </LibItemContainer>
  );
}

export default React.memo(RowImage, areEqual);
